import React, { Component } from "react";
import { cognito } from "../../../utils/cognito";
import { config } from "../../../utils/config";
import { redirectTo, xhr } from "../../../utils/window-utils";
import spinner from "../../main/assets/images/resources/loader25.gif";
import ErrorModal from "./ErrorModal";
import AlreadyOnboardedModal from "./AlreadyOnboardedModal";
import Texts from "../../../utils/lang-utils";
import ProgressBar from "./ProgressBar";

const complete = async (token, onPrevious) => {
  if (!token) {
    token = await cognito.getToken();
  }

  const data = JSON.parse(localStorage.getItem("join-state"));

  const variables = {
    restaurantName: data.restaurantName,
    spreadsheetId: data.spreadsheetId,
    lang: navigator.language.split("-")[0],
    refreshToken: token.refresh_token,
  };
  const response = await xhr(config.MenuApiUrl, {
    method: "POST",
    body: JSON.stringify({
      query: `mutation ($restaurantName: String!, $lang: String!, $spreadsheetId: String!, $refreshToken: String!) {onboardRestaurant(restaurantName: $restaurantName, lang: $lang, refreshToken: $refreshToken, spreadsheetId: $spreadsheetId)}`,
      variables,
    }),
    headers: new Headers({ Authorization: token.id_token, "Content-Type": "application/json" }),
  }).catch(console.log);

  const onboardingResult = await response?.json();

  return onboardingResult;
};

const handleErrors = (result) => {
  debugger;
  if (result.data?.onboardRestaurant === "ALREADY_ONBOARDED") {
    throw new Error("ErrorType.onboarded");
  } else {
    if (result.errors && result.errors.length && result.errors[0].errorType === "ExecutionTimeout") {
      throw new Error("ErrorType.timeout");
    }
    throw new Error("ErrorType.critical");
  }
};

export default class OnboardingComplete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      criticalError: false,
      haveAccountError: false,
      token: props.token,
      onPrevious: props.onPrevious,
      completed: false,
      additionalInfo: false
    };
  }

  async redirectToAdmin(result) {
    this.setState({ completed: true });
    await new Promise((res) => setTimeout(res, 500));
    redirectTo(`${config.AdminUrl}#${result ? result.data.onboardRestaurant.split(":")[1] : ''}`);
  }

  handleTimeout() {
    this.setState({ additionalInfo: true });
    setTimeout(() => {
      this.redirectToAdmin(null);
    }, 10000);
  }
  async componentDidMount() {
    try {
      const result = await complete(this.state.token, this.state.onPrevious);
      debugger;
      if (result?.data?.onboardRestaurant?.startsWith("OK")) {
        this.redirectToAdmin(result);
      } else {
        handleErrors(result);
      }
    } catch (err) {
      switch (err.message) {
        case "ErrorType.onboarded":
          this.setState({ haveAccountError: true });
          break;
        case "ErrorType.timeout":
          this.handleTimeout();
          break;
        default:
          this.setState({ criticalError: true });
      }
    }
  }

  render() {
    return (
      <>
        {!this.state.criticalError && !this.state.haveAccountError && (
          <div className="spinner extra">
            <span>{Texts.onboarding.wait}</span>
            <div className="progress-indicators">
              <img src={spinner}></img>
              <ProgressBar duration={25} wait completed={this.state.completed} />
              {this.state.additionalInfo && <span className="almost-done">{Texts.onboarding.Preparing}</span>}
            </div>
          </div>
        )}
        {this.state.criticalError && <ErrorModal onPrevious={this.state.onPrevious} />}
        {this.state.haveAccountError && <AlreadyOnboardedModal onPrevious={this.state.onPrevious} />}
      </>
    );
  }
}
